import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { FaPrint, FaSync } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const CourseMaterialUpload = () => {
  const [userId, setUserId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [caption, setCaption] = useState("");
  const [materialLink, setMaterialLink] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      console.error("User ID not found in session storage.");
    }
    // Fetch classes
    axios
      .get(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => {
        setClasses(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });

    // Fetch subjects
    axios
      .post(
        `${BASE_URL}/admin/subject/list_all_subject_to_teacher.php`,
        {
          pass: userId,
        }
      )
      .then((response) => {
        console.log("====================================");
        console.log(response);
        console.log("====================================");
        setSubjects(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
      });
  }, []);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    const fileBase64 = await toBase64(file);

    const user_id = sessionStorage.getItem("user_id"); // Get the user_id from session storage

    const postData = {
      pass: user_id, // Matching the 'pass' parameter in PHP
      class_id: selectedClass,
      subject_id: selectedSubject,
      file_name: fileName || file.name,
      material_file: fileBase64, // The file in base64 format
      caption: caption || "",
      material_link: materialLink || "",
    };

    try {
      const response = await axios.post(
        `${BASE_URL}/staff/course_materials/create_course_material.php`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setMessage("Course material uploaded successfully!");
      } else {
        setMessage(
          `Failed to upload course material: ${
            response.data.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      setMessage("An error occurred while uploading the course material.");
    }
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Course Material</h1>
            <div className="action-buttons"></div>
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Course Material</span> /{" "}
            <span>Upload</span>
          </div>
        </div>
        <Box
          mt={6}
          p={6}
          bg="white"
          borderRadius="md"
          boxShadow="md"
          mx="auto"
          maxWidth={{ base: "90%", sm: "80%", md: "70%", lg: "60%" }}
        >
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}  p={{base:"2",md:"6"}}> 
              {message && (
                <Alert
                  status={
                    message.includes("successfully") ? "success" : "error"
                  }
                >
                  <AlertIcon />
                  {message}
                </Alert>
              )}

              <FormControl id="class" isRequired>
                <FormLabel>Class</FormLabel>
                <Select
                  placeholder="Select Class"
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="subject" isRequired>
                <FormLabel>Subject</FormLabel>
                <Select
                  placeholder="Select Subject"
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                >
                  {subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="file" isRequired>
                <FormLabel>Course Material File</FormLabel>
                <Input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </FormControl>

              <FormControl id="fileName">
                <FormLabel>File Name</FormLabel>
                <Input
                  type="text"
                  value={fileName}
                  onChange={(e) => setFileName(e.target.value)}
                  placeholder="Enter file name"
                />
              </FormControl>

              <FormControl id="caption">
                <FormLabel>Caption</FormLabel>
                <Input
                  type="text"
                  value={caption}
                  onChange={(e) => setCaption(e.target.value)}
                />
              </FormControl>

              <FormControl id="materialLink">
                <FormLabel>Material Link</FormLabel>
                <Input
                  type="text"
                  value={materialLink}
                  onChange={(e) => setMaterialLink(e.target.value)}
                />
              </FormControl>

              <Button colorScheme="teal" type="submit">
                Upload
              </Button>
            </VStack>
          </form>
        </Box>
      </div>
    </Box>
  );
};

export default CourseMaterialUpload;
